// extracted by mini-css-extract-plugin
export default {"complexTitle":"ItemRow_complexTitle__zgIRf","zero":"ItemRow_zero__T4l--","placeHolderShimmer":"ItemRow_placeHolderShimmer__Wab4O"};